import React from 'react';
import { useIntl } from 'react-intl';
import type { TooltipProps } from '@mui/material/Tooltip';

import Tooltip from 'components/mui/Tooltip';
import { BetaLabel } from 'components/BetaBadge/StyledComponents';

export interface BetaBadgeProps extends React.ComponentProps<typeof BetaLabel> {
  /**
   * Forwarded to the underlying Tooltip's `slotProps`. Used by the chat header to
   * lift the tooltip Popper above the chat Drawer (zIndex 1600) so it isn't hidden.
   */
  tooltipSlotProps?: TooltipProps['slotProps'];
}

const BetaBadge: React.FC<BetaBadgeProps> = ({ tooltipSlotProps, ...props }) => {
  const { formatMessage } = useIntl();

  return (
    <Tooltip
      title={formatMessage({
        id: 'tooltip.betaBadge',
        defaultMessage: 'Beta feature: Currently under evaluation and customers feedback gathering',
      })}
      slotProps={tooltipSlotProps}
    >
      <BetaLabel {...props}>{formatMessage({ id: 'labels.beta', defaultMessage: 'Beta' })}</BetaLabel>
    </Tooltip>
  );
};

export default BetaBadge;
